import { render, staticRenderFns } from "./NotPublic.vue?vue&type=template&id=a26ccefa"
import script from "./NotPublic.vue?vue&type=script&lang=js"
export * from "./NotPublic.vue?vue&type=script&lang=js"
import style0 from "./NotPublic.vue?vue&type=style&index=0&id=a26ccefa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports